import { QueryClient, useQuery } from '@tanstack/vue-query'
import QueryKeys from '@/vue-query/QueryKeys'
import { useUserProjectDisplaySettingsApi } from '../api/useUserProjectDisplaySettingsApi'
import { useParams } from '../utils/useParams'
import { UserProjectDisplaySettingsDto } from '~/api/contracts/models'

export function useUserProjectDisplaySettingsQuery() {
   const { projectId } = useParams()
   
   const client = useUserProjectDisplaySettingsApi()
   
   const enabled = computed(() => !!projectId.value)

   return useQuery([QueryKeys.UserProjectDisplaySettings, projectId], () => client.get(projectId.value), { enabled: enabled, refetchOnWindowFocus: false, staleTime: Infinity})
}

export function useUserProjectDisplaySettingsQueryPrefetch(
   queryClient: QueryClient,
   projectId: Ref<string>
): Promise<void> {
   const client = useUserProjectDisplaySettingsApi()
   return queryClient.prefetchQuery<UserProjectDisplaySettingsDto>(
      [QueryKeys.UserProjectDisplaySettings, projectId],
      () => client.get(projectId.value)
   )
}